import { z } from 'zod';

// Execution events streamed from backend → frontend during a workflow run.

export const executionEventSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('execution-started'),
        runId: z.string(),
        workflowId: z.string(),
        at: z.string(),
    }),
    z.object({
        type: z.literal('node-started'),
        runId: z.string(),
        nodeId: z.string(),
        at: z.string(),
    }),
    z.object({
        type: z.literal('node-token'),
        runId: z.string(),
        nodeId: z.string(),
        token: z.string(),
    }),
    z.object({
        type: z.literal('node-finished'),
        runId: z.string(),
        nodeId: z.string(),
        output: z.string(),
        durationMs: z.number(),
    }),
    z.object({
        type: z.literal('node-error'),
        runId: z.string(),
        nodeId: z.string(),
        message: z.string(),
    }),
    z.object({
        type: z.literal('execution-finished'),
        runId: z.string(),
        workflowId: z.string(),
        durationMs: z.number(),
    }),
    z.object({
        type: z.literal('execution-error'),
        runId: z.string(),
        workflowId: z.string(),
        message: z.string(),
    }),
]);
export type ExecutionEvent = z.infer<typeof executionEventSchema>;

// Client → server messages over the run subscription channel.
export const clientMessageSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('subscribe-run'),
        runId: z.string(),
    }),
    z.object({
        type: z.literal('cancel-run'),
        runId: z.string(),
    }),
]);
export type ClientMessage = z.infer<typeof clientMessageSchema>;
